export enum TaskDefaultView {
  'DETAILED' = '',
  'FORM' = 'FORM',
  'CHECK_LIST' = 'CHECK_LIST',
  'INTERVENTION' = 'INTERVENTION',
}
